/** 从 myshopify 域名解析 store handle，如 `foo.myshopify.com` → `foo` */
export const getShopHandle = (shop: string): string =>
  shop?.split(".")?.[0] ?? ""

/** 生成新版 Shopify Admin 外链：`https://admin.shopify.com/store/{handle}/{path}` */
export const getShopifyAdminUrl = (shop: string, path: string): string => {
  const handle = getShopHandle(shop)
  const normalizedPath = path.replace(/^\//, "")
  return `https://admin.shopify.com/store/${handle}/${normalizedPath}`
}
